import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";

export async function createCarSession(payload: Record<string, unknown>) {
  const response = await axiosInstance.post(App_Url_New.ApiEndPoint.createSession, payload);

  return response.data;
}

export async function updateCarSessionStep(params: {
  step: string;
  payload: Record<string, unknown>;
  clientId: string | number;
  sessionId: string | number;
  lobId: number;
}) {
  const { step, payload, clientId, sessionId, lobId } = params;

  return axiosInstance.post(App_Url_New.ApiEndPoint.updateSession, {
    step,
    payload,
    client_id: clientId,
    session_id: sessionId,
    lob_id: lobId,
  });
}

export async function currentInsurerType() {
  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.currentInsurerType);
  return response.data;
}

export async function currentInsurer() {
  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.currentInsurer);
  return response.data;
}
export async function noClaimCertificate() {
  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.noClaimCertificate);
  return response.data;
}

type VehicleApiItem = Record<string, unknown> | string | number;

const getList = (payload: unknown): VehicleApiItem[] => {
  if (Array.isArray(payload)) return payload as VehicleApiItem[];

  if (payload && typeof payload === "object") {
    const response = payload as Record<string, unknown>;
    for (const key of ["data", "results", "items", "vehicles", "model_years", "specifications"]) {
      if (Array.isArray(response[key])) return response[key] as VehicleApiItem[];
    }

    if (response.data && typeof response.data === "object") return getList(response.data);
  }

  return [];
};

export async function getVehicles() {
  const response = await axiosInstance.get(App_Url_New.ApiEndPoint.motorVehicles);
  return getList(response.data);
}

export async function getVehicleModelYears(vehicleId: string | number) {
  const response = await axiosInstance.get(
    `${App_Url_New.ApiEndPoint.motorVehicles}/${vehicleId}/model-years`
  );
  return getList(response.data);
}

export async function getVehicleSpecifications(vehicleId: string | number, modelYear: string) {
  const response = await axiosInstance.get(
    `${App_Url_New.ApiEndPoint.motorVehicles}/${vehicleId}/specifications`,
    { params: { model_year: modelYear } }
  );
  return getList(response.data);
}
